import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation sendTasksToAdoMutation($input: SendTasksToAdoInput!) {
		sendTasksToAdo(input: $input) {
			tasks {
				id
				vstsId
				name
				statusColumnV2 {
					id
					name
					category
				}
			}
			updatedTasksIds
			errors
		}
	}
`;

function commit(environment, input, onCompleted, onError) {
	tracking.trackEvent('Send tasks to Ado');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				...input,
			},
		},
		onCompleted,
		onError,
	});
}

export default {commit};
